import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneOffer from './submodules/clone';
import OfferConversions from './submodules/conversions';
import CreateOffer from './submodules/create';
import OfferList from './submodules/list';
import EditOffer from './submodules/edit';

const CtdDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDActiveOffers]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={OfferList}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createCTDOffers]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneOffer}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createCTDOffers]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateOffer}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDOffers]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/conversionDetails`}
				component={OfferConversions}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateCTDOffers]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={EditOffer}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default CtdDashboard;
